import { VIEWING_FORM_MODE_RESET_VALUES } from './useViewingFormChangeFields.constants'

export function getViewingFormModeResetValues(mode) {
  return VIEWING_FORM_MODE_RESET_VALUES[mode]
}
